import { API_MYEDUZZ } from 'settings';
import { LAST_SEVEN_DAYS_OFFSET } from 'v2/components/Pages/Dashboard/period';

import { apiServiceProxy, type ApiServiceProxy } from '../api-proxy';

type NewsItem = {
  id: number;
  title: string;
  has_content: boolean;
  external_url?: string;
  show_tag_new?: boolean;
};

class DashboardMainService {
  constructor(private apiService: ApiServiceProxy) {}

  public async listNewzz(quantity?: number) {
    const params = quantity ? `?per_page=${quantity}` : '';
    return this.apiService.get<NewsItem[]>(`${API_MYEDUZZ}/news${params}`);
  }

  public async clickNewzz(id: number) {
    return this.apiService.post(`${API_MYEDUZZ}/news/${id}/click`, {});
  }

  public async bestsellers(days: '7' | '30' | 'all' = '7') {
    const lastPeriodDays = days === '7' ? LAST_SEVEN_DAYS_OFFSET : days;
    const params = days !== 'all' ? `?last_period_days=${lastPeriodDays}` : '';
    return this.apiService.get(`${API_MYEDUZZ}/dashboard/bestsellers${params}`);
  }

  public async lastGain(startDate?: string, endDate?: string) {
    const params = startDate && endDate ? `?start_date=${startDate}&end_date=${endDate}` : '';
    return this.apiService.get(`${API_MYEDUZZ}/dashboard/lastgains${params}`);
  }
}

export const dashboardMainService = new DashboardMainService(apiServiceProxy);
